var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"author-container"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.getTag.name))]),_vm._l((_vm.posts),function(post,index){return _c('div',{key:index,staticClass:"post-list-container"},[_c('PostsItem',{attrs:{"post":post}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }